import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal } from 'antd';
import Container from '../meta/Container';
import Meta from '../meta-runner';
import TitleTips from '../meta/TitleTips';
import Toolbar from '../meta/Toolbar';
import DefineModal from '../meta/DefineModal'
import * as ModalIndex from '../modal';
import * as ExternalModal from '../../../../common/components/modal';

import * as dynamicModalActions from '../../redux/dynamicModal';
import Table2D from '../basic/table2D';
//FLH 2D Move 2D Table To YXYWeb
const ModalMap = {};
Object.assign(ModalMap, ModalIndex);
Object.assign(ModalMap, ExternalModal);

class DynamicModal extends Component {
  close() {
    const { dynamicModalActions, dynamicModal } = this.props;
    const { panes } = dynamicModal;
    const activePane = panes[panes.length - 1];
    dynamicModalActions.closeModal();
    if (activePane.content && activePane.content.vm)
      activePane.content.vm.execute('afterClose');
    else if (activePane.groupCode) {
      activePane.viewModel.execute('afterClose', activePane.groupCode);
    }
  }
  handleOk(viewModel, groupCode) {
    viewModel.promiseExecute('afterOkClick', { key: groupCode }, () => {
      this.close();
    });
  }
  defineClose = (viewModel) => {
    viewModel.promiseExecute('beforeClose',{},()=>{
      this.props.dynamicModalActions.closeModal();
    })
  }
  defineOk = (viewModel) => {
    viewModel.promiseExecute('beforeSave',{},()=>{
      this.props.dynamicModalActions.closeModal();
    })
  }
  handleSave = () => {
    const { dynamicModal, dynamicModalActions } = this.props;
    const { panes } = dynamicModal;
    const activePane = panes[panes.length - 1];
    const viewModel = activePane.content.vm;
    const beforeSave = (beforeActData, callback) => {
      beforeActData.close = function () {
        dynamicModalActions.closeModal();
      };
      viewModel.promiseExecute('beforeSave', beforeActData, callback);
    };
    const afterSave = (afterActData, callback) => {
      viewModel.promiseExecute('afterSave', afterActData, function () {
        callback && callback(afterActData);
      });
    };
    viewModel.biz.action().save(viewModel.getParams().billNo, viewModel, null, beforeSave, function (afterSaveData) {
      afterSave(afterSaveData, function () {
        if (afterSaveData.err) {
          cb.utils.alert(afterSaveData.err.message, 'error');
          return;
        }
        dynamicModalActions.closeModal();
        const parentViewModel = viewModel.getCache('parentViewModel');
        if (parentViewModel)
          parentViewModel.execute('back');
      });
    });
  }
  render() {
    const { dynamicModal } = this.props;
    const { panes } = dynamicModal;
    if (!panes || !panes.length)
      return null;
    const modals = [];
    panes.forEach(item => {
      modals.push(this.renderItem(item));
    });
    // if (modals.length === 1)
    //   return modals[0];
    return (
      <div>{modals}</div>
    );
  }
  renderItem(item) {
    const { groupCode, viewModel, title, content, modalConfig } = item;
    if (groupCode) {
      const meta = viewModel.getViewMeta(groupCode);
      const containerType = meta.cControlType && meta.cControlType.trim().toLocaleLowerCase();
      if (containerType === 'modal') {
        const container = Object.assign({}, meta, { cControlType: 'div' });
        const width = 800;
        let cStyle = {}
        if (meta.cStyle) {
          try {
            cStyle = JSON.parse(meta.cStyle);
          } catch (e) {
            cStyle = {}
          }
        }
        const extraConfig = {
          visible: true,
          maskClosable: false,
          width
        };
        if (cStyle.toolbar === false) {
          extraConfig.footer = null;
        } else {
          extraConfig.onOk = () => this.handleOk(viewModel, groupCode)
        }
        return (
          <Modal {...extraConfig} className='Table' title={meta.cName} wrapClassName={cStyle.classname} onCancel={() => this.close()}>
            <Container className='modal-container' meta={container} viewModel={viewModel} width={width} parents='Modal' />
          </Modal>
        );
      }
      return null;
    }
    if (content) {
      const metaData = JSON.parse(JSON.stringify(content.metaData));
      const { iWidth, containers } = metaData.view;
      const toolbarIndex = containers.findIndex(item => {
        return item.cControlType && item.cControlType.trim().toLocaleLowerCase() === 'toolbar';
      });
      const footerIndex = containers.findIndex(item => {
        return item.cControlType && item.cControlType.trim().toLocaleLowerCase() === 'footer';
      });
      let cStyle = containers[0].cStyle;
      let config = [];
      let modelclassname, needToolbar;
      if (cStyle) {
        try {
          cStyle = JSON.parse(cStyle);
          config = cStyle.config || [];
          modelclassname = cStyle.modelclassname;
          needToolbar = cStyle.toolbar;
        } catch (e) {
          config = []
        }
      }
      let extraConfig = {
        visible: true,
        maskClosable: (cStyle && cStyle.maskClosable) ? cStyle.maskClosable : false,
        width: iWidth
      }
      if (modelclassname) {
        extraConfig.className = modelclassname
      }
      if (toolbarIndex > -1) {
        extraConfig.footer = <Toolbar controls={containers[toolbarIndex].controls} model={content.vm} />
        containers.splice(toolbarIndex, 1);
      } else if (footerIndex > -1) {
        containers[footerIndex].cControlType = 'div';
        extraConfig.footer = <Container meta={containers[footerIndex]} viewModel={content.vm} width={iWidth} parents='Modal' />
        containers.splice(footerIndex, 1);
      } else if (needToolbar === false) {
        extraConfig.footer = null;
      } else {
        extraConfig.onOk = this.handleSave
      }
      return (
        <Modal {...extraConfig} title={<div>{title}{config.length ? <TitleTips config={config} /> : null}</div>} onCancel={() => this.close()}>
          {/* <Container meta={content.metaData.view} viewModel={content.vm} width={iWidth} parents='Modal' /> */}
          <Meta metaData={metaData} viewModel={content.vm} width={iWidth} />
        </Modal>
      );
    }
    if (item.key == "openTable2D") {
      return (<Table2D
        {...item.data}
        close={() => this.close()}
      />
      );
    }
    if (modalConfig) {
      const extraConfig = {
        visible: true,
        maskClosable: false,
        width: 900
      };
      return (
        <Modal {...extraConfig} className='Table' title={title} wrapClassName={'yxy_define_modal'}
          onCancel={() => this.defineClose(viewModel)} onOk={() => this.defineOk(viewModel)}>
          <DefineModal viewModel={viewModel} config={modalConfig} />
        </Modal>
      )
    }
    const ComName = ModalMap[item.key];
    if (!ComName)
      return null;
    return <ComName {...item.data} close={() => this.close()} />;
  }
}

function mapStateToProps(state) {
  return {
    dynamicModal: state.dynamicModal.toJS()
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dynamicModalActions: bindActionCreators(dynamicModalActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DynamicModal);



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/portal/DynamicModal.jsx